import React, { useEffect, useState } from "react";
import _ from "lodash";
import medicalFillInFormItemTypes from "../../../../constants/chart-sidebar/medicalFillInFormItemTypes";
import { medicalFillInFormStackCodes } from "../../../../constants/chart-sidebar/medicalFIllInFormStackCodes";
import MedicalFillInFormInitialExaminationList from "./MedicalFillInFormInitialExaminationList";
import MedicalFillInFormInitialExaminationItem from "./MedicalFillInFormInitialExaminationItem";
import MedicalFillInFormOwnedList from "./MedicalFillInFormOwnedList";
import MedicalFillInFormList from "./MedicalFillInFormList";
import MedicalFillInFormView from "./MedicalFillInFormView";
import MedicalFillInFormPrint from "./MedicalFillInFormPrint";

import { connect, useDispatch } from "react-redux";
import {
  getConsultationTemplateListApi,
  getMedicalFillInFormEmpty,
  getMedicalFillInFormTabList,
  medicalFillInFormToggleMenu,
  onSaveMedicalFillInFormItem,
  pushStack,
  resetConsultationId,
  updateStack,
  saveConsultationInitialExaminationItem,
  setActiveTab,
  getMedicalFormConsultationInitialExaminationItem,
  disableInitialExaminationTabToggle,
  openTextarea,
  medicalTypeFilterHandler,
  getMedicalFillInFormTemplateList,
  getMedicalFillInFormHistoryTabList,
  getMedicalFillInFormHistoryList,
} from "../../../../actions/chartSideMedicalFillInFormActions";

import Show from "../../../widgets/Show";
import ChartOrder from "../../../order/ChartOrder";
import { Sidebar } from "../../../sidebar/Sidebar";
import MedicalFormsTextArea from "./MedicalFormsTextArea";
import MedicalFIllInFormItem from "./MedicalFIllInFormItem";
import MedicationList from "../../../medication/MedicationList";
import MedicalFillInFormPostOp from "./MedicalFillInFormPostOp";
import MedicalFillInFormVitals from "./MedicalFillInFormVitals";
import MedicalFillInFormHeader from "./MedicalFillInFormHeader";
import PatientFormsList from "../../../patient/PatientFormsList";
import MedicalFormsAddendumList from "./MedicalFormsAddendumList";
import MedicalFormsAddendumItem from "./MedicalFormsAddendumItem";
import { createUrl, parseQuery } from "../../../../utils/UrlUtils";
import BackImage from "../../../../assets/images/white-icon-back.png";
import MedicalFIllInFormEntryPage from "./MedicalFIllInFormEntryPage";
import MedicalFillInformTreatment from "./MedicalFillInformTreatment";
import MedicalFillInFormDiagnosis from "./MedicalFillInFormDiagnosis";
import MedicalFillInFormConsentFormView from "./MedicalFillInFormConsentFormView";
import MedicalFillInFormConsentFormEdit from "./MedicalFillInFormConsentFormEdit";
import MemberPasswordRequestModal from "../../../member/MemberPasswordRequestModal";
import MedicalFillInFormVitalsCreateForm from "./MedicalFillInFormVitalsCreateForm";
import MedicalFillInFormTreatmentComplete from "./MedicalFillInFormTreatmentComplete";
import PatientMedicalAlertsEdit from "../../../patient/alerts/PatientMedicalAlertsEdit";
import { closeSimpleModal, openSimpleModal } from "../../../../actions/simpleModalActions";
import MedicalFillInFormProvisionalDiagnosis from "./MedicalFillInFormProvisionalDiagnosis";
import { RESET_MEDICAL_FILL_IN_FORM_FOR } from "../../../../actionTypes/medicalFillInFormActionTypes";

const enhancer = connect(
  ({
    patientRegister,
    appointment,
    transaction,
    insurance,
    chart,
    session: {
      permissions,
      miscSettings: { initialExaminationRequireApproval },
      clinic: { id: clinicId, name: clinicName },
    },
    chartSideMedicalFillInForm,
  }) => ({
    chart,
    clinicId,
    clinicName,
    permissions,
    appointment,
    patientRegister,
    images: insurance.images,
    chartSideMedicalFillInForm,
    initialExaminationRequireApproval,
    diagnosisClaimTypeList: transaction.diagnosisClaimTypeList,
    fetchingTransactionList: transaction.fetchingProvisionalList,
    provisionalDiagnosisList: transaction.provisionalDiagnosisList,
  }),
);
let canUserEdit = false;

const MedicalFillInForm = (props) => {
  const {
    appointment,
    chartSideMedicalFillInForm,
    diagnosisClaimTypeList,
    chart,
    location,
    history,
    patientKey,
    clinicId,
    permissions,
    images,
    clinicName,
    initialExaminationRequireApproval,
    provisionalDiagnosisList,
    fetchingTransactionList,
    patientRegister,
  } = props;
  const {
    stack,
    item,
    templateTabList,
    activeTab,
    consultationId,
    treatmentList,
    treatmentListFetching,
    diagnosisList,
    diagnosisListFetching,
    medicalFillInFormMenuVisible,
    patientVitalTransactionFetching,
    initialExaminationItem,
    initialExaminationConsultation,
    isInitialExaminationTabDisable,
    medicalTypeFilter,
    appointmentMedicalFillInFormSidebarVisible,
  } = chartSideMedicalFillInForm;
  const { memberPasswordRequestModalVisible } = patientRegister;
  const dispatch = useDispatch();
  const [form, setForm] = useState(item);
  const [initialExaminationForm, setInitialExaminationForm] = useState(
    initialExaminationConsultation,
  );
  const stackItem = _.last(stack);
  const isEditMode =
    stackItem?.type === medicalFillInFormItemTypes.edit ||
    stackItem?.type === medicalFillInFormItemTypes.new;
  const query = parseQuery(location?.search);
  const plannedAppointment = appointmentMedicalFillInFormSidebarVisible
    ? _.get(appointment, "appointment")
    : _.get(chart, "appointment");
  useEffect(() => {
    dispatch(getMedicalFillInFormTabList());
    dispatch(getMedicalFillInFormEmpty());

    if (!_.get(query, "patientKey")) {
      const patientKey = _.get(appointment, ["item", "patient", "patientKey"]);
      history.replace(createUrl(location?.pathname, { query: { ...query, patientKey } }));
    }

    return () => {
      dispatch(resetConsultationId());
      dispatch(updateStack({ code: medicalFillInFormStackCodes.entry }));
      dispatch({ type: RESET_MEDICAL_FILL_IN_FORM_FOR });
      history.replace(
        createUrl(location?.pathname, { query: { ...query, medicalType: undefined } }),
      );
    };
  }, []);

  useEffect(() => {
    if (stackItem?.code === medicalFillInFormStackCodes.entry && isInitialExaminationTabDisable) {
      dispatch(disableInitialExaminationTabToggle(false));
    }
  }, [stackItem]);

  useEffect(() => {
    if (stackItem.code === medicalFillInFormStackCodes.entry) {
      if (medicalTypeFilter !== "new") {
        dispatch(medicalTypeFilterHandler("new"));
      }

      if (plannedAppointment?.id) {
        dispatch(
          getConsultationTemplateListApi({ appointmentId: plannedAppointment.id, patientKey }),
        )
          .then((response) => {
            canUserEdit = !response?.consultationId;
          })
          .catch(() => {
            canUserEdit = true;
          });
      }
    }
  }, [stackItem]);

  const onSaveItem = () => {
    if (form.questions.length) {
      dispatch(
        onSaveMedicalFillInFormItem({
          ...form,
          templates: null,
          consultationId,
          appointmentId: plannedAppointment?.id,
          patientKey,
        }),
      );
      dispatch(
        getMedicalFillInFormHistoryList({
          consultationId,
          templateId: form.template.id,
          templateTypeId: form.template.templateTypeId,
        }),
      );
    }
    if (initialExaminationForm.questions.length && activeTab.isInitialExamination) {
      dispatch(
        saveConsultationInitialExaminationItem({
          ...initialExaminationForm,
          templates: null,
          consultationId,
          appointmentId: plannedAppointment?.id,
          patientKey,
        }),
      );

      dispatch(
        getMedicalFillInFormHistoryList({
          consultationId,
          templateId: initialExaminationForm.template.id,
          templateTypeId: initialExaminationForm.template.templateTypeId,
        }),
      );
    }
  };
  const consultationStartHandler = () => {
    const { templateTabList } = chartSideMedicalFillInForm;
    const isEntryPage =
      stackItem.code === medicalFillInFormStackCodes.entry && activeTab.isInitialExamination;
    history.replace(
      createUrl(location.pathname, {
        query: {
          ...query,
          medicalType: undefined,
        },
      }),
    );
    dispatch(getMedicalFillInFormTabList(true));
    dispatch(getMedicalFillInFormTemplateList());
    if (
      isEntryPage &&
      initialExaminationRequireApproval &&
      _.get(initialExaminationItem, "approved", true)
    ) {
      if (templateTabList?.length) {
        dispatch(setActiveTab(templateTabList[1]));
      }
    }

    const initialExaminationTab = (templateTabList || []).find((tab) =>
      Boolean(tab.isInitialExamination),
    );
    if (
      initialExaminationRequireApproval &&
      !_.get(initialExaminationItem, "approved", true) &&
      initialExaminationItem.consultationId
    ) {
      return dispatch(
        openSimpleModal({
          body: "Please approve initial examination!",
          footer: (
            <div className="d-flex align-items-center justify-content-end">
              <button
                className="btn btn-success ml-3"
                onClick={() => {
                  dispatch(setActiveTab(initialExaminationTab));
                  dispatch(closeSimpleModal());
                  dispatch(getMedicalFormConsultationInitialExaminationItem());
                  dispatch(
                    pushStack({
                      code: medicalFillInFormStackCodes.ownedList,
                      type: medicalFillInFormItemTypes.view,
                    }),
                  );
                }}
              >
                Ok
              </button>
            </div>
          ),
        }),
      );
    } else {
      dispatch(
        pushStack({
          code: medicalFillInFormStackCodes.item,
          type: medicalFillInFormItemTypes.new,
        }),
      );
    }
  };

  return (
    <div className="medical-fill-in-form">
      <Sidebar
        fullScreen={chartSideMedicalFillInForm.fullScreen}
        show={chartSideMedicalFillInForm.openTextArea}
        backdrop={"static"}
        keyboard={false}
        shouldCloseOnEsc={false}
        onHide={() => dispatch(openTextarea(false))}
        dialogClassName="chart-side-bar"
      >
        <MedicalFormsTextArea />
      </Sidebar>
      <MedicalFillInFormHeader
        chartSideMedicalFillInForm={chartSideMedicalFillInForm}
        stackItem={stackItem}
        templateTabList={templateTabList}
        activeTab={activeTab}
        onSaveItem={onSaveItem}
        form={form}
        patientKey={patientKey}
        initialExaminationRequireApproval={initialExaminationRequireApproval}
      />
      <div
        className={`medical-fill-in-form__body ${
          !medicalFillInFormMenuVisible ? "menu-visible" : ""
        }`}
      >
        {/*left side*/}
        <div className="medical-fill-in-form__body__left-side">
          <div className="menu-toggler" onClick={() => dispatch(medicalFillInFormToggleMenu())}>
            <img
              src={BackImage}
              style={!medicalFillInFormMenuVisible ? { transform: `rotate(180deg)` } : {}}
              width={12}
              alt=""
            />
          </div>
          {/*<button*/}
          {/*  className="btn btn-default"*/}
          {/*  type="button"*/}
          {/*  onClick={() => dispatch(medicalFillInFormToggleMenu())}*/}
          {/*>*/}
          {/*  {!medicalFillInFormMenuVisible ? "Show menu" : "Hide menu"}*/}
          {/*</button>*/}
          <Show if={stackItem.code === medicalFillInFormStackCodes.entry}>
            <button
              onClick={() => {
                dispatch(getMedicalFillInFormHistoryTabList());
                dispatch(medicalTypeFilterHandler("view"));

                dispatch(disableInitialExaminationTabToggle(true));
                dispatch(
                  pushStack({
                    code: medicalFillInFormStackCodes.ownedList,
                    type: medicalFillInFormItemTypes.view,
                  }),
                );
              }}
              className="btn btn-primary btn-block"
            >
              <span>View Historical Forms/Consults</span>
            </button>
          </Show>
          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.ownedList &&
              stackItem?.type === medicalFillInFormItemTypes.view &&
              activeTab.isInitialExamination
            }
          >
            <MedicalFillInFormInitialExaminationList
              history={history}
              patientKey={patientKey}
              location={location}
              chartSideMedicalFillInForm={chartSideMedicalFillInForm}
              initialExaminationRequireApproval={initialExaminationRequireApproval}
              initialExaminationItem={initialExaminationItem}
              initialExaminationForm={initialExaminationForm}
              setInitialExaminationForm={setInitialExaminationForm}
              onSaveItem={onSaveItem}
            />
          </Show>
          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.ownedList &&
              (stackItem?.type === medicalFillInFormItemTypes.view ||
                stackItem?.type === medicalFillInFormItemTypes.print)
            }
          >
            <div className="d-flex flex-column justify-content-between" style={{ height: "100%" }}>
              <div style={{ height: "49%" }}>
                <MedicalFillInFormOwnedList
                  permissions={permissions}
                  history={history}
                  location={location}
                  patientKey={patientKey}
                  chartSideMedicalFillInForm={chartSideMedicalFillInForm}
                />
              </div>
              <Show
                if={
                  stackItem.code !== medicalFillInFormStackCodes.ownedList &&
                  (stackItem?.type === medicalFillInFormItemTypes.view ||
                    stackItem?.type === medicalFillInFormItemTypes.edit)
                }
              >
                <div style={{ height: "49%" }}>
                  <MedicalFillInFormList
                    history={history}
                    patientKey={patientKey}
                    location={location}
                    chartSideMedicalFillInForm={chartSideMedicalFillInForm}
                    showOnlyHardcodedList={true}
                    initialExaminationRequireApproval={initialExaminationRequireApproval}
                    initialExaminationItem={initialExaminationItem}
                    onSaveItem={onSaveItem}
                  />
                </div>
              </Show>
            </div>
          </Show>

          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.item ||
              stackItem.code === medicalFillInFormStackCodes.consentForms ||
              stackItem.code === medicalFillInFormStackCodes.medicalAlerts ||
              stackItem.code === medicalFillInFormStackCodes.treatment ||
              stackItem.code === medicalFillInFormStackCodes.drugTreatment ||
              stackItem.code === medicalFillInFormStackCodes.diagnosis ||
              stackItem.code === medicalFillInFormStackCodes.prescription ||
              stackItem.code === medicalFillInFormStackCodes.order ||
              stackItem.code === medicalFillInFormStackCodes.postOp ||
              stackItem.code === medicalFillInFormStackCodes.treatmentComplete ||
              stackItem.code === medicalFillInFormStackCodes.vitals ||
              stackItem.code === medicalFillInFormStackCodes.vitalsCreateForm ||
              stackItem.code === medicalFillInFormStackCodes.labOrder ||
              stackItem.code === medicalFillInFormStackCodes.radiologyOrder ||
              stackItem.code === medicalFillInFormStackCodes.provisionalDiagnosis
            }
          >
            <Show if={activeTab.name !== "Addendums"}>
              <MedicalFillInFormList
                history={history}
                patientKey={patientKey}
                location={location}
                chartSideMedicalFillInForm={chartSideMedicalFillInForm}
                initialExaminationRequireApproval={initialExaminationRequireApproval}
                initialExaminationItem={initialExaminationItem}
                onSaveItem={onSaveItem}
              />
            </Show>
            <Show if={activeTab.name === "Addendums"}>
              <MedicalFormsAddendumList chartSideMedicalFillInForm={chartSideMedicalFillInForm} />
            </Show>
          </Show>
        </div>
        {/*right side*/}
        <div className="medical-fill-in-form__body__right-side">
          <Show if={stackItem.code === medicalFillInFormStackCodes.entry}>
            <div className="d-flex align-items-end justify-content-end">
              <button
                disabled={!canUserEdit}
                onClick={consultationStartHandler}
                className="btn btn-default mt-2"
              >
                <span>Click here to start FORM/Consult</span>
              </button>
            </div>
            <MedicalFIllInFormEntryPage />
          </Show>

          <Show
            if={
              activeTab.name !== "Addendums" &&
              stackItem?.type === medicalFillInFormItemTypes.view &&
              !activeTab.isInitialExamination
            }
          >
            <MedicalFillInFormView
              history={history}
              location={location}
              permissions={permissions}
              chartSideMedicalFillInForm={chartSideMedicalFillInForm}
              clinicName={clinicName}
              patientKey={patientKey}
            />
          </Show>

          <Show
            if={
              activeTab.name !== "Addendums" &&
              stackItem?.type === medicalFillInFormItemTypes.print &&
              !activeTab.isInitialExamination
            }
          >
            <MedicalFillInFormPrint
              history={history}
              location={location}
              permissions={permissions}
              chartSideMedicalFillInForm={chartSideMedicalFillInForm}
              clinicName={clinicName}
              patientKey={patientKey}
            />
          </Show>

          <Show if={activeTab.name === "Addendums"}>
            <MedicalFormsAddendumItem chartSideMedicalFillInForm={chartSideMedicalFillInForm} />
          </Show>

          <Show
            if={
              !activeTab.isInitialExamination &&
              stackItem.code === medicalFillInFormStackCodes.item &&
              (stackItem?.type === medicalFillInFormItemTypes.new ||
                stackItem?.type === medicalFillInFormItemTypes.edit ||
                stackItem?.type === medicalFillInFormItemTypes.view)
            }
          >
            <MedicalFIllInFormItem
              patient={chart.patient}
              images={images}
              clinicName={clinicName}
              onSaveItem={onSaveItem}
              setForm={setForm}
              form={form}
              editMode={isEditMode}
              history={history}
              location={location}
              chartSideMedicalFillInForm={chartSideMedicalFillInForm}
            />
          </Show>
          <Show
            if={
              activeTab.isInitialExamination &&
              stackItem.code === medicalFillInFormStackCodes.item &&
              stackItem?.type === medicalFillInFormItemTypes.view
            }
          >
            <MedicalFillInFormInitialExaminationItem
              images={images}
              editMode={false}
              history={history}
              location={location}
              patient={chart.patient}
              onSaveItem={onSaveItem}
              clinicName={clinicName}
              permissions={permissions}
              patientKey={patientKey}
              initialExaminationForm={initialExaminationForm}
              setInitialExaminationForm={setInitialExaminationForm}
              chartSideMedicalFillInForm={chartSideMedicalFillInForm}
            />
          </Show>
          <Show
            if={
              activeTab.isInitialExamination &&
              stackItem.code === medicalFillInFormStackCodes.item &&
              (stackItem?.type === medicalFillInFormItemTypes.new ||
                stackItem?.type === medicalFillInFormItemTypes.edit)
            }
          >
            <MedicalFillInFormInitialExaminationItem
              images={images}
              editMode={true}
              history={history}
              location={location}
              patient={chart.patient}
              onSaveItem={onSaveItem}
              clinicName={clinicName}
              permissions={permissions}
              patientKey={patientKey}
              initialExaminationForm={initialExaminationForm}
              setInitialExaminationForm={setInitialExaminationForm}
              chartSideMedicalFillInForm={chartSideMedicalFillInForm}
            />
          </Show>

          <Show if={stackItem.code === medicalFillInFormStackCodes.prescription}>
            <MedicationList location={location} medicalForms={true} />
          </Show>

          <Show if={stackItem.code === medicalFillInFormStackCodes.order}>
            <ChartOrder medicalForms={true} />
          </Show>

          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.consentForms &&
              stackItem?.type === medicalFillInFormItemTypes.list
            }
          >
            <PatientFormsList medicalForms={true} />
          </Show>

          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.consentForms &&
              stackItem?.type === medicalFillInFormItemTypes.view
            }
          >
            <MedicalFillInFormConsentFormView />
          </Show>

          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.consentForms &&
              stackItem?.type === medicalFillInFormItemTypes.edit
            }
          >
            <MedicalFillInFormConsentFormEdit location={location} history={history} />
          </Show>

          <Show if={stackItem.code === medicalFillInFormStackCodes.medicalAlerts}>
            <PatientMedicalAlertsEdit
              medicalForms={true}
              location={location}
              history={history}
              stackItem={stackItem}
              medicalFillInFormItemTypes={medicalFillInFormItemTypes}
            />
          </Show>

          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.treatment ||
              stackItem.code === medicalFillInFormStackCodes.drugTreatment
            }
          >
            <MedicalFillInformTreatment
              chart={chart}
              clinicId={clinicId}
              patientKey={patientKey}
              treatmentList={treatmentList}
              fetching={treatmentListFetching}
              permissions={permissions}
              history={history}
            />
          </Show>
          <Show if={stackItem.code === medicalFillInFormStackCodes.treatmentComplete}>
            <MedicalFillInFormTreatmentComplete
              chart={chart}
              clinicId={clinicId}
              onSaveItem={onSaveItem}
              patientKey={patientKey}
              treatmentList={treatmentList}
              fetching={treatmentListFetching}
              permissions={permissions}
              history={history}
            />
          </Show>

          <Show if={stackItem.code === medicalFillInFormStackCodes.diagnosis}>
            <MedicalFillInFormDiagnosis
              chart={chart}
              clinicId={clinicId}
              permissions={permissions}
              diagnosisList={diagnosisList}
              fetching={diagnosisListFetching}
              diagnosisClaimTypeList={diagnosisClaimTypeList}
            />
          </Show>

          <Show if={stackItem.code === medicalFillInFormStackCodes.provisionalDiagnosis}>
            <MedicalFillInFormProvisionalDiagnosis
              chart={chart}
              clinicId={clinicId}
              permissions={permissions}
              diagnosisList={provisionalDiagnosisList}
              fetching={fetchingTransactionList}
              diagnosisClaimTypeList={diagnosisClaimTypeList}
            />
          </Show>
          <Show if={stackItem.code === medicalFillInFormStackCodes.postOp}>
            <MedicalFillInFormPostOp history={history} location={location} />
          </Show>
          <Show if={stackItem.code === medicalFillInFormStackCodes.vitals}>
            <MedicalFillInFormVitals
              chart={chart}
              clinicId={clinicId}
              patientKey={patientKey}
              fetching={patientVitalTransactionFetching}
              permissions={permissions}
              history={history}
              stackItem={stackItem}
              medicalFillInFormItemTypes={medicalFillInFormItemTypes}
            />
          </Show>
          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.vitalsCreateForm &&
              stackItem?.type === medicalFillInFormItemTypes.new
            }
          >
            <MedicalFillInFormVitalsCreateForm
              chart={chart}
              clinicId={clinicId}
              patientKey={patientKey}
              treatmentList={treatmentList}
              fetching={treatmentListFetching}
              permissions={permissions}
              history={history}
              location={location}
              mode={"add"}
            />
          </Show>

          <Show
            if={
              stackItem.code === medicalFillInFormStackCodes.vitalsCreateForm &&
              stackItem?.type === medicalFillInFormItemTypes.edit
            }
          >
            <MedicalFillInFormVitalsCreateForm
              chart={chart}
              clinicId={clinicId}
              patientKey={patientKey}
              treatmentList={treatmentList}
              fetching={treatmentListFetching}
              permissions={permissions}
              history={history}
              location={location}
              mode={"edit"}
            />
          </Show>
          <MemberPasswordRequestModal
            size="sm"
            title="Member Password Request"
            show={memberPasswordRequestModalVisible}
          />
        </div>
      </div>
    </div>
  );
};

export default enhancer(MedicalFillInForm);
